import { Component, OnInit, Input, Output, EventEmitter, Optional, inject, Inject, OnChanges } from '@angular/core';
import {
  CorrespondenceDataObj,
  ITemplate,
  ISaveCorrespondenceActivity,
  DataIds,
  CorrespondenceActivity,
} from '../../../shared/models/activity-dashboard-model';
import { ActivityService } from '../../../core/services/activity.service';
import { FileService } from '../../../core/services/file.service';
import { Template } from '../../../shared/models/createschedule';
import { MAT_DIALOG_DATA , MatDialog} from '@angular/material/dialog'; 
import { MatDialogRef } from '@angular/material/dialog'; 
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';
import { SchedulerCandidate, ActivitiesOnCandidate } from '../../../shared/models/schedulerAssociate';
import { AssociateService } from '../../schedulerpersona/services/associate.service';
import { ConfirmPopupComponent} from '../../../shared/components/confirm-popup/confirm-popup.component';
import { ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
export interface Status {
  value: string;
}

@Component({
  selector: 'app-coupled-correspoandence-activity',
  templateUrl: './coupled-correspoandence-activity.component.html',
  styleUrls: ['./coupled-correspoandence-activity.component.scss'],
  standalone: false,
})
export class CoupledCorrespoandenceActivityComponent implements OnInit, OnChanges {
  editactivity: any = false;
  userloggedin: any;
  loginUserName: any;
  editCreatedOn: any;
  firstcreatedon: string;
  clauseId: number;

  @Input() isSelected: boolean;
  @Input() reasonlist: any;
  @Input() activityId:any;
  confirmDialog = inject(MatDialog);
  constructor(private activityService: ActivityService,
    private fileService: FileService,
    private associateService: AssociateService,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.correspondenceDataObj = data.correspondenceDataObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
      this.candidateEmails = data.candidateEmails;
    }
  }

  public ccEnable: boolean = false;
  public bccEnable: boolean = false;

  public isCollapsed: boolean = false;

  //time
  public timeModifiedOn: string;
  templateData: ITemplate[];

  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  toggleBtn: boolean = false;

  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  companyHiringType: any; //= 1;
  placeholderMapping: any[] = [];
  templateIndex: any;
  @Input() interviewFlag: boolean;
  @Input() selectedTemplate: any;
  @Input() InterviewTemplateData: ITemplate[];
  ids: DataIds;
  comments: string = 'ABC';
  @Input() correspondenceDataObj: CorrespondenceDataObj;
  @Input() candidateApplicationIds: number[];
  @Input() candidateEmails: string[];
  @Input() ifCoupled: boolean;
  @Input() selectedClauseIndex: any;
  @Input() selectedCandidate: SchedulerCandidate[];
  template: Template[];
  templateDisable: boolean = false;
  ccInputValue: string;
  bccInputValue: string;
  toInputValue: string;
  subjectInputValue: string;
  bodyInputValue: string;
  remarksInputValue: string;
  candidateData: ActivitiesOnCandidate;
  candidateMail: any = [];
  templateId: number;
  toDisable: boolean = false;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  @Output() refreshCoupledcorres: EventEmitter<any> = new EventEmitter();
  @Output() coupledformValid: EventEmitter<boolean> = new EventEmitter();
  @Output() notSavedEmitter: EventEmitter<any> = new EventEmitter();
  @Input() createdonEdit: any;
  ROA: boolean = false;
  temaplateName: any;
  RejectionMailCheck: boolean = false;
  ngOnInit() {
    this.RejectionMailCheck = this.isSelected;
    console.log('loginuser---->', this.userloggedin);
    console.log('candidateemails-->', this.candidateEmails);
    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);
    if (this.reasonlist) {
      if (this.activityId == 500305) {
        if (this.reasonlist[1].toLowerCase().includes('tech')) {
          for (const status of this.templateData) {
            if (status.templateName.toLowerCase().includes('tech')) {
              this.selectedTemplate = status.templateId;
              this.getTemplateData({ value: this.selectedTemplate });
            }
          }
        } else if (this.reasonlist[1].toLowerCase().includes('salary')) {
          for (const status of this.templateData) {
            if (status.templateName.toLowerCase().includes('salary')) {
              this.selectedTemplate = status.templateId;
              this.getTemplateData({ value: this.selectedTemplate });
            }
          }
        } else {
          for (const status of this.templateData) {
            if (
              !status.templateName.toLowerCase().includes('salary') &&
              !status.templateName.toLowerCase().includes('tech')
            ) {
              this.selectedTemplate = status.templateId;
              this.getTemplateData({ value: this.selectedTemplate });
            }
          }
        }
      }
      if (this.activityId == 500307) {
        for (const status of this.templateData) {
          this.selectedTemplate = status.templateId;
          this.getTemplateData({ value: this.selectedTemplate });
        }
      }
    }

    if (this.correspondenceDataObj.rejection == true) {
      this.ROA = true;
    } else {
      this.RejectionMailCheck = true;
    }
    this.isCollapsed = true;
    this.loginUserName = this.userloggedin.username;

    this.candidateEmails.forEach((mail) => {
      console.log('index of mail--->', mail.indexOf(mail));
    });
    console.log(this.loginUserName);
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');

    //placeholder
    //   if(!this.editactivity)
    //   {
    //   this.selectedCandidate.forEach(value=>{

    //   this.associateService.getActivitiesOnCandidate(value.applicationId,value.candidateId).subscribe(data=>
    //     {
    //       console.log(data);
    //       this.candidateData=data;

    //       let obj=
    //         {

    //         fname:this.candidateData.fname,
    //         lname:this.candidateData.lname,
    //         candidateId:value.candidateId,
    //           //this.correspondenceDataObj.candidateName
    //         }
    //         this.placeholderMapping.push(obj);
    //         this.candidateMail.push(value.email);
    //     })

    //   });
    // }
    // else{
    //   this.associateService.getActivitiesOnCandidate(this.correspondenceDataObj.applicationId,this.correspondenceDataObj.candidateId).subscribe(data=>
    //     {
    //       console.log(data);
    //       this.candidateData=data;

    //       let obj=
    //         {

    //         fname:this.candidateData.fname,
    //         lname:this.candidateData.lname,
    //         candidateId:this.correspondenceDataObj.candidateId,
    //           //this.correspondenceDataObj.candidateName
    //         }
    //         this.placeholderMapping.push(obj);
    //         this.candidateMail.push(this.candidateEmails[0]);
    //     })

    // }

    //placeholder ends
    console.log('this.correspondance data obj', this.correspondenceDataObj);
    // this.editId = { objectId: this.correspondenceDataObj.applicationId, objectType: 'AP' };
    console.log('emails---->', this.candidateEmails);

    this.toInputValue = this.candidateEmails[0];
    this.toDisable = true;
    console.log(this.interviewFlag);
    if (!this.interviewFlag) {
      this.selectedTemplate = -1;

      this.subjectInputValue = '';
      this.bodyInputValue = '';
      this.remarksInputValue = '';
      this.ccInputValue = '';
      this.bccInputValue = '';
    }

    if (!this.editactivity) {
      if (this.correspondenceDataObj && this.correspondenceDataObj.activityId && this.correspondenceDataObj.processId) {
        this.activityService
          .getTemplate(this.correspondenceDataObj.activityId, this.correspondenceDataObj.processId)
          .subscribe((data) => {
            this.templateData = data;
            console.log('templte data---', this.templateData);
          });
      }
    }
    if (this.editactivity) {
      this.editId = {
        objectId: this.correspondenceDataObj.applicationId,
        objectType: 'AP',
        activityId: this.correspondenceDataObj.activityId,
      };
      if (this.correspondenceDataObj && this.correspondenceDataObj.activityId && this.correspondenceDataObj.processId) {
        this.activityService
          .getTemplate(this.correspondenceDataObj.activityId, this.correspondenceDataObj.processId)
          .subscribe((data) => {
            this.templateData = data;
            this.getActivity(this.correspondenceDataObj, this.createdonEdit);
            console.log('templte data---', this.templateData);
          });
      }
      // .applicationId, this.correspondenceDataObj.activityId, this.correspondenceDataObj.processId);
    }
  }

  // createdOnValue(event)
  // {
  //   if (this.editactivity) {
  //     this.editId = { objectId: this.correspondenceDataObj.applicationId, objectType: 'AP',activityId:this.correspondenceDataObj.activityId };
  //     this.activityService.getTemplate(this.correspondenceDataObj.activityId,this.correspondenceDataObj.processId).subscribe(data => {
  //       this.templateData = data;
  //       this.getActivity(this.correspondenceDataObj,event);
  //       console.log("templte data---",this.templateData);

  //     });

  //     // .applicationId, this.correspondenceDataObj.activityId, this.correspondenceDataObj.processId);
  //   }
  // }
  testformValid(flag) {
    // console.log('couple form valid',this.selectedTemplate,flag);
    if (this.RejectionMailCheck != true) {
      this.coupledformValid.emit(true);
    } else {
      if (flag == true && this.selectedTemplate == -1) {
        this.coupledformValid.emit(false);
      } else if (flag == true && this.selectedTemplate != -1) {
        this.coupledformValid.emit(true);
      } else {
        this.coupledformValid.emit(false);
      }
    }
  }

  ngOnChanges() {
    this.RejectionMailCheck = this.isSelected;
    this.toInputValue = this.candidateEmails[0];
    if (!this.interviewFlag) {
      this.selectedTemplate = -1;

      this.subjectInputValue = '';
      this.bodyInputValue = '';
      this.remarksInputValue = '';
      this.ccInputValue = '';
      this.bccInputValue = '';
    }

    if (this.reasonlist) {
      if (this.activityId == 500305) {
        if (this.reasonlist[1].toLowerCase().includes('tech')) {
          for (const status of this.templateData) {
            if (status.templateName.toLowerCase().includes('tech')) {
              this.selectedTemplate = status.templateId;
              this.getTemplateData({ value: this.selectedTemplate });
            }
          }
        } else if (this.reasonlist[1].toLowerCase().includes('salary')) {
          for (const status of this.templateData) {
            if (status.templateName.toLowerCase().includes('salary')) {
              this.selectedTemplate = status.templateId;
              this.getTemplateData({ value: this.selectedTemplate });
            }
          }
        } else {
          for (const status of this.templateData) {
            if (
              !status.templateName.toLowerCase().includes('salary') &&
              !status.templateName.toLowerCase().includes('tech')
            ) {
              this.selectedTemplate = status.templateId;
              this.getTemplateData({ value: this.selectedTemplate });
            }
          }
        }
      }
      if (this.activityId == 500307) {
        for (const status of this.templateData) {
          this.selectedTemplate = status.templateId;
          this.getTemplateData({ value: this.selectedTemplate });
        }
      }
    }
    if (this.interviewFlag) {
      this.templateDisable = true;
      console.log(this.InterviewTemplateData);
      if (this.selectedClauseIndex >= 0) {
        this.bodyInputValue = this.InterviewTemplateData[this.selectedClauseIndex].templateBody;
        this.subjectInputValue = this.InterviewTemplateData[this.selectedClauseIndex].templateSubject;
      }
    }
  }

  // toggle enable/disable CC in correspondace activity
  ccEnableDisable() {
    console.log(this.ccEnable);
    this.ccEnable = !this.ccEnable;
    console.log(this.ccEnable);
  }

  getTemplateData(event) {
    console.log(event);

    console.log('placeholder--->', this.placeholderMapping);
    console.log('candidateMail--->', this.candidateMail);
    console.log('candidateEmail---->', this.candidateEmails);
    // if(!this.editactivity)
    // {

    this.templateIndex = this.templateData.findIndex((item) => item.templateId === event.value);
    this.templateId = this.templateData[this.templateIndex].templateId;
    this.clauseId = this.templateData[this.templateIndex].clauseid;
    this.temaplateName = this.templateData[this.templateIndex].templateName;
    // let p =this.displayText(this.templateData[this.templateIndex].templateBody,0);

    this.bodyInputValue = this.templateData[this.templateIndex].templateBody;
    this.subjectInputValue = this.templateData[this.templateIndex].templateSubject;
    // }


  }

  isTemplateLocked(template: ITemplate | undefined): boolean {
     this.activityId = this.activityId?? this.activityService.getAct();
    if (this.companyHiringType == 4 && this.activityId == 200304) {
      return template ? [905,906,907, 908, 909].indexOf(template.templateId) === -1 : true;
    }
    return false;
  }

  // toggle enable/disable BCC in correspondace activity
  bccEnableDisable() {
    this.bccEnable = !this.bccEnable;
  }

  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }

  getActivity(obj: CorrespondenceDataObj, createdOn) {
    //  obj.createdOn
    console.log('correspondence activity get activity');
    this.activityService
      .getCorrespondenceActivity(obj.applicationId, obj.activityId, obj.processId, createdOn)
      .subscribe((response: CorrespondenceActivity) => {
        console.log(response, createdOn);
        this.firstcreatedon = response.createdOn;
        if (response.createdOn == null) {
          this.editCreatedOn = createdOn;
        } else {
          this.editCreatedOn = response.createdOn;
        }
        if (response.clause_id == null) {
          this.ROA = true;
          this.RejectionMailCheck = false;
        } else {
          this.ROA = true;
        }
        this.dataInitialization(response);
      });
  }

  dataInitialization(activityObj) {
    if (activityObj.createdOn === '') {
      //this.notes ='';
      //this.isDeleteDisable = true;
      console.log('IF_inside dataInitialization');
    } else {
      //this.notes = this.checkSuitabilityDataObj.simpleActivity.notes;
      //this.isDeleteDisable = false;
      console.log('ELSE_inside dataInitialization', activityObj);
      this.correspondenceDataObj.correspondenceActivity = activityObj;
      this.comments = activityObj.comments;
      this.remarksInputValue = activityObj.comments;
      if (activityObj.cc != '' && activityObj.cc != null) {
        this.ccEnable = true;
      }
      if (activityObj.bcc != '' && activityObj.bcc != null) {
        this.bccEnable = true;
      }
      //  this.ccEnable=true;
      //  this.bccEnable=true;
      this.ccInputValue = activityObj.cc;
      this.bccInputValue = activityObj.bcc;
      // time
      this.timeModifiedOn = this.correspondenceDataObj.correspondenceActivity.modifiedOn;
      console.log(activityObj);
      //template binding
      if (activityObj.clause_id) {
        this.selectedTemplate = activityObj.templateclauseModel.templateId;
        this.templateIndex = this.templateData.findIndex(
          (item) => item.templateId === activityObj.templateclauseModel.templateId,
        );
        console.log(this.templateIndex, this.templateData);
        if (this.templateIndex >= 0) {
          this.templateId = this.templateData[this.templateIndex].templateId;
          this.clauseId = this.templateData[this.templateIndex].clauseid;
          this.temaplateName = this.templateData[this.templateIndex].templateName;
          console.log('templateid--', this.templateId, 'clauseid--', this.selectedTemplate);
          //  let p =this.displayText(this.templateData[this.templateIndex].templateBody,0);
          //  this.bodyInputValue=p;
          this.bodyInputValue = activityObj.templateclauseModel.templateBody; //this.templateData[this.templateIndex].templateBody;
          this.subjectInputValue = this.templateData[this.templateIndex].templateSubject;
        }
      } else {
      }
    }
  }

  //put communication

  getFormValue() {
    console.log(this.ccInputValue);
  }
  send(createdOn?: any) {

    if (this.isCandidateCommunicationRequired()) {
      this.showCandidateCommunicationRequiredMessage();
      return;
    }

    if (this.editactivity) {
      console.log('inside if');

      this.editCorresActivity(createdOn);
    } else {
      if (this.RejectionMailCheck == true) {
        this.saveCorresActivity(createdOn);
      } else {
        this.refreshCoupledcorres.emit('true');
      }
    }
    // this.refreshcandiates.emit("true");

  }

  isCandidateCommunicationRequired(): boolean {
    return this.ROA && !this.RejectionMailCheck && this.companyHiringType == 4;
  }

  showCandidateCommunicationRequiredMessage() {
    const dialogData = new ConfirmDialogModel('', "Please select 'Send Email Communication to the Candidate' to proceed with the application rejection.");
    this.confirmDialog.open(ConfirmPopupComponent, {
      maxWidth: "500px",
      data: dialogData,
      disableClose: true
    })
  }

  saveInterviewCorresActivity(processId, activityId, _applicationId) {
    console.log(this.ccInputValue);
    console.log('inside saveInterview correspondence');

    this.saveAttachment(this.correspondenceDataObj.applicationId, this.companyHiringType, activityId, null, null);

    this.associateService.recruiterActivity.subscribe((result) => {
      const postDataObj1: ISaveCorrespondenceActivity = {
        applicationIds: this.candidateApplicationIds,
        processId: result.interviewMail.processId,
        activityId: result.interviewMail.activityId,
        comments: this.remarksInputValue,
        clause_id: this.clauseId,
        mailerID: 1010,
        // "clausMasterList": null,
        cc: this.ccInputValue,
        bcc: this.bccInputValue,
        templateId: this.templateId,
        mobileRequest: false,
        eventId: null,
        templateSubject: this.subjectInputValue,
        templateBody: this.bodyInputValue,
      };
      console.log('savecoress obj for interview---', postDataObj1);
      if (postDataObj1 && postDataObj1.applicationIds && postDataObj1.activityId && postDataObj1.processId) {
        this.activityService.saveCorrespondenceActivity(postDataObj1).subscribe((res1) => {
          console.log(res1);
        });
      }
    });

    //mailer integration
    // for(let i =0;i<this.candidateEmails.length;i++){

    //   console.log("index of mail-->",i);
    // const fd = new FormData();
    // fd.append('from', 'talentacquisition@infosys.com')
    // fd.append('subject', this.subjectInputValue);

    // if (this.ccInputValue != null) {
    //   fd.append('ccArray', this.ccInputValue)
    // }

    // if (this.fileData != null) {
    //   this.fileData.forEach(file => {
    //     fd.append('file[' + file.name + ']', file);

    //   });
    // }
    //   fd.append('to', this.candidateEmails[i]);
    //   let p =this.displayText(this.templateData[this.templateIndex].templateBody,i);
    //   fd.append('body',p)

    //   this.activityService.sendEmail(fd).subscribe(
    //     (res) => {
    //       console.log(res);
    //     },
    //     (err) => {
    //       console.log(err)
    //     }
    //   )
    // }
    //mailer integration ends
  }

  saveCorresActivity(createdOn?: any) {
    if (this.firstcreatedon == null && this.editactivity == true) {
      const appid = [];
      appid.push(this.correspondenceDataObj.applicationId);
      const postDataObj: ISaveCorrespondenceActivity = {
        applicationIds: appid,
        processId: this.correspondenceDataObj.processId,
        activityId: this.correspondenceDataObj.activityId,
        comments: this.remarksInputValue,
        clause_id: this.clauseId,
        mailerID: 1010,
        // "clausMasterList": null,
        cc: this.ccInputValue,
        bcc: this.bccInputValue,
        templateId: this.templateId,
        mobileRequest: false,
        eventId: null,
        templateBody: this.bodyInputValue,
        templateSubject: this.subjectInputValue,
        createdOn: this.editCreatedOn,
      };

      this.saveAttachment(
        this.correspondenceDataObj.applicationId,
        this.companyHiringType,
        this.correspondenceDataObj.activityId,
        postDataObj,
        null,
      );
    } else {
      const postDataObj: ISaveCorrespondenceActivity = {
        applicationIds: this.candidateApplicationIds,
        processId: this.correspondenceDataObj.processId,
        activityId: this.correspondenceDataObj.activityId,
        comments: this.remarksInputValue,
        clause_id: this.clauseId,
        mailerID: 1010,
        // "clausMasterList": null,
        cc: this.ccInputValue,
        bcc: this.bccInputValue,
        templateId: this.templateId,
        mobileRequest: false,
        eventId: null,
        templateBody: this.bodyInputValue,
        templateSubject: this.subjectInputValue,
        createdOn: createdOn,
      };

      this.saveAttachment(
        this.correspondenceDataObj.applicationId,
        this.companyHiringType,
        this.correspondenceDataObj.activityId,
        postDataObj,
        null,
      );
    }

    this.showMoreLess();
  } // end of put

  saveMailservice(postDataObj) {
    this.activityService.saveCorrespondenceActivity(postDataObj).subscribe(
      (data1) => {
        console.log(data1);
        if (data1.error && data1.error.toLowerCase() === 'failure') {
          const data2 = {
            msg: data1.message,
            isSuccess: 'error',
          };

          this.activityService.openSnackBar(data2, 'danger-snack');
        } else {
          if (!this.editactivity) {
            this.refreshCoupledcorres.emit('true');
          }
          const data2 = {
            msg: data1.message,
            isSuccess: 'created',
          };
          this.activityService.openSnackBar(data2, 'success-snack');
        }
      },
      (err) => {
        const data3 = {
          msg: 'Some error occurred',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data3, 'danger-snack');
        console.log('err-->', err);
      },
    );
    this.showMoreLess();
  }
  editCorresActivity(createdOn?: any) {
    // to,cc,bcc,sub,body
    console.log('puting working', createdOn, this.editCreatedOn);
    const Obj1: CorrespondenceActivity = {
      applicationIds: this.correspondenceDataObj.applicationId,
      processId: this.correspondenceDataObj.processId,
      activityId: this.correspondenceDataObj.activityId,
      comments: this.remarksInputValue,
      clause_id: this.clauseId,
      mailerID: 1010,
      // "clausMasterList": null,
      cc: this.ccInputValue,
      bcc: this.bccInputValue,
      createdOn: this.editCreatedOn, //createdOn,
      createdBy: this.correspondenceDataObj.createdBy,
      template_Id: this.templateId,
      templateSubject: this.subjectInputValue,
      templateBody: this.bodyInputValue,
      eventId: null,
      mobileRequest: false,
    };

    //  console.log(postDataObj);
    if (this.RejectionMailCheck == true) {
      this.saveAttachment(
        this.correspondenceDataObj.applicationId,
        this.companyHiringType,
        this.correspondenceDataObj.activityId,
        null,
        Obj1,
      );
    }
    this.dialogRef.close();
  }

  editMailService(Obj1) {
    this.activityService.editCorrespondenceActivity(Obj1).subscribe(
      (datas) => {
        console.log(datas);
        const data2 = {
          msg: 'Data Updated Successfully !!! ',
          isSuccess: true,
        };
        this.activityService.openSnackBar(data2, 'success-snack');
        this.dialogRef.close();
      },
      (err) => {
        console.log('err-->', err);
        const data2 = {
          msg: err,
          isSuccess: false,
        };
        this.activityService.openSnackBar(data2, 'danger-snack');
      },
    );
  }

  // file upload
  receiveFileOutput(filedata2) {
    console.log('inside recievefile format');
    this.fileData = filedata2['fileMerge1'];
    this.deletedFile = filedata2['deletedFile1'];
  }

  saveAttachment(genericIdNew, companyHiringTypeId, activityid2, saveObj, editObj) {
    console.log('inside saveattachmnt suitability');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );
      });
    }

    const activityId = activityid2; //this.correspondenceDataObj.activityId;

    const fd3 = new FormData();
    fd3.append('objectId', genericIdNew);
    fd3.append('objectType', 'AP');
    fd3.append('attachmentId', '2');
    fd3.append('companyHiringTypeId', companyHiringTypeId);
    fd3.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fd3.append('file[' + file.name + ']', file);
      });
      console.log(fd3);
      this.fileService.upload(fd3).subscribe(
        (_res) => {},
        (_err) => {},
      );
    }
    if (this.editactivity) {
      this.editMailService(editObj);
    } else {
      if (saveObj) {
        this.saveMailservice(saveObj);
      }
    }
  }

  displayText(text1, index): string {
    console.log('text--->', text1, index);
    const candidate = this.placeholderMapping[index];
    console.log(candidate);
    const result = text1.replace(/\<\<(.*?)\>\>/g, function (match, token) {
      return candidate[token];
    });
    console.log('result--->', result);
    return result;
  }
}
